const MOBILE_BREAKPOINT = 992;

function handleHeadingClick(sideNav) {
  if (window.innerWidth <= MOBILE_BREAKPOINT) {
    sideNav.classList.toggle('active');
  }
}

export default function initSideNavigationMobile() {
  const sideNavigations = document.querySelectorAll('.side-menunav, .widget_twc_widget_nav_menu');

  if (!sideNavigations.length) {
    return;
  }

  sideNavigations.forEach((sideNav) => {
    const heading = sideNav.querySelector('.aside__heading, .sidebar-widget__title');

    if (!heading) {
      return;
    }

    heading.addEventListener('click', () => handleHeadingClick(sideNav));
  });
}
